import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MaintenanceGuard } from './guard/maintenance.guard';
import { RedirectToV2Guard } from './guard/redirect-to-v2.guard';

const routes: Routes = [
  { path: 'auth', canActivate: [MaintenanceGuard], loadChildren: () => import('./views/layouts/auth/auth.module').then(m => m.AuthModule) },
  { path: 'producer', canActivate: [MaintenanceGuard], loadChildren: () => import('./views/pages/producer/app/app.module').then(m => m.AppModule) },
  { path: '', canActivate: [MaintenanceGuard, RedirectToV2Guard], loadChildren: () => import('./views/layouts/home/home.module').then(m => m.HomeModule) },
  { path: 'maintenance', loadChildren: () => import('./views/layouts/maintenance/maintenance.module').then(m => m.MaintenanceModule) },
  { path: '', canActivate: [MaintenanceGuard], loadChildren: () => import('./views/layouts/main/main.module').then(m => m.MainModule) },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
